<template>
  <div :class="`m-portal .m-portal-nav-top`">
    <header class="ljh-header clearfix">
      <div class="ljh-logo-wrap">
        <img
          class="ljh-logo animated zoomIn delay-0.5s"
          src="../../assets/portal/logo.png"
          alt="朱子文化综合信息服务平台"
        />
        <img class="ljh-zhu-xi f-right" src="../../assets/portal/zuzi.jpg" alt="朱子格竹" />
      </div>
      <div style="width:100%;background:#510000;">
        <div style="width: 1100px;margin: 0px auto;height:40px;">
          <el-menu
            :default-active="activeIndex[$route.params._field]"
            class="el-menu-demo"
            mode="horizontal"
            text-color="#FFF5E7"
            active-text-color="#510000"
          >
            <el-menu-item
              style="width:14.28%;height:40px;text-align: center;line-height: 40px;"
              index="1"
            >
              <a
                style="font-size: 1.8rem;font-weight: bold;text-decoration:none;"
                @click="handlePortal"
              >首页</a>
            </el-menu-item>
            <el-menu-item
              @click="information"
              style="font-size: 1.8rem;font-weight: bold;width:14.28%;text-align:center;height:40px;line-height: 40px;"
              index="2"
            >文化资讯</el-menu-item>
            <el-menu-item
              @click="culture('culture','zzwh','2648fa10-2354-4527-a6e7-fe583b008c03')"
              style="font-size: 1.8rem;font-weight: bold;width:14.28%;text-align:center;height:40px;line-height: 40px;"
              index="3"
            >文化概述</el-menu-item>
            <el-menu-item
              style="width:14.28%;height:40px;text-align: center;line-height: 40px;"
              index="4"
            >
              <a
                style="font-size: 1.8rem;font-weight: bold;text-decoration:none;"
                :href="$app.url.zzzg"
                target="_blank"
              >文化展馆</a>
            </el-menu-item>
            <el-menu-item
              style="width:14.28%;height:40px;text-align: center;line-height: 40px;"
              index="5"
            >
              <a
                style="font-size: 1.8rem;font-weight: bold;text-decoration:none;"
                :href="$app.url.whyc"
                target="_blank"
              >文化遗存</a>
            </el-menu-item>
            <el-menu-item
              @click="travel('destinations','spot')"
              style="font-size: 1.8rem;font-weight: bold;width:14.28%;text-align:center;height:40px;line-height: 40px;"
              index="6"
            >文化旅游</el-menu-item>
            <el-menu-item
              style="width:14.28%;height:40px;text-align: center;line-height: 40px;"
              index="7"
            >
              <a
                style="font-size: 1.8rem;font-weight: bold;text-decoration:none;"
                :href="$app.url.zzsc"
                target="_blank"
              >文化商城</a>
            </el-menu-item>
          </el-menu>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
require("../../styles/portal/index-portal.scss");
export default {
  data() {
    return {
      activeIndex: {
        undefined: "2",
        xwzx_detail: "2",
        hdgg_detail: "2",
        llyj_detail: "2",
        dwjl_detail: "2",
        brower_detail:"2",
        xwzx: "2",
        hdgg: "2",
        llyj: "2",
        dwjl: "2",
        song: "3",
        jdxb: "3",
        lxcb: "3",
        zzzg: "3",
        zzgs: "3",
        whyc: "3",
        kw: "3",
        whjt: "3",
        jysx: "3",
        info: "3",
        zzcp: "3",
        zzln: "3",
        zzsl: "3",
        zzlx: "3",
        zzwh: "3",        
        zzln_detail: "3",
        zzlx_detail: "3",
        jdxb_detail: "3",
        zzcp_detail: "3",
        jysx_detail: "3",
        zzgs_detail: "3",
        whyc_detail: "3",
        whyc_page: "3",
        whjt_page: "3",
        zzsl_page: "3",
        whjt_detail: "3",
        "3d": "6",
        "720": "6",
        vr: "6",
        spot: "6",
        hotel: "6",
        ticket: "6",
        food: "6",
        spot_detail: "6",
        hotel_detail: "6",
        travel_detail: "6",
        ticket_detail: "6",
        food_detail: "6",
        travel: "6",
        yjgl: "6",
        yjgl_detail: "6",
        classics:"6",
        classics_detail:"6",
      }
    };
  },
  methods: {
    handlePortal() {
      // this.$router.push({
      //   path: "/portal"
      // });
      window.location.href = `/portal`
    },
    information() {
      this.$router.push({
        path: "/portal/new/main"
      });
    },
    culture(moudle, field, cultId) {
      this.$router.push({
        path: `/portal/cult/detail/${moudle}/${field}/${cultId}`
      });
    },
    hall() {
      this.$router.push({
        path: "/portal/hall"
      });
    },
    remains() {
      this.$router.push({
        path: "/portal/remains"
      });
    },
    travel(moudle, field) {
      this.$router.push({
        path: `/portal/dest/page/${moudle}/${field}`
      });
    }
  }
};
</script>

<style scoped>
</style>